/**
 * Created by Pankaj on 09/Sep/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SequentiallyBetLineInitialWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/initial/sequentially/SequentiallyBetLineInitialWPController";
import {Ease, Timeline, TimelineLite, TweenLite} from "gsap";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {RomanEmpireInitialWinCountUp} from "./RomanEmpireInitialWinCountUp";
import {IBetLineBothWayWinData, RomanEmpireParsedGameData} from "../../server/data/RomanEmpireParsedGameData";
import {IBetLineWinData, IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {RomanEmpireGameModuleConfig} from "../../RomanEmpireGameModuleConfig";
import {LineShine, LineShineMask} from "../betline/LineSprite";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {RomanEmpireEvents} from "../../events/RomanEmpireEvents";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IShineMask} from "../betline/RomanEmpirePolyBetLine";
import {RomanEmpireGameMode} from "../../gamemode/RomanEmpireGameMode";
import {AnimatedMultiplier} from "./AnimatedMultiplier";
import {RomanEmpireInitialWPView} from "./RomanEmpireInitialWPView";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SoundManager} from "../../resource/sound/SoundManager";
import {RomanEmpireSoundConfig} from "../../RomanEmpireSoundConfig";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ISymbolPositions} from "../geniefeature/GenieFeatureController";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {RomanEmpire} from "../../RomanEmpire";


export interface RomanEmpireBetLineWinData extends IBetLineWinData {
    extraWildMultiplier: number;
}

export interface IPosition {
    x: number,
    y: number
}

export class RomanEmpireInitialWPController extends SequentiallyBetLineInitialWPController {

    public static readonly BET_LINE_MIN_DURATION = 0.6;
    private readonly _winCountUp: RomanEmpireInitialWinCountUp;
    private readonly _multiplierContainer: PIXI.Container;
    private _masterTimeline: TimelineLite;
    private readonly BETLINE_ANIM_TIME_OFFSET: number = 0.3;
    private readonly GENIE_RESPIN_BETLINE_ANIM_TIME_OFFSET = 0.3;
    private _multiplierTotalAnimDuration: number;
    private readonly _shineContainerLeft: PIXI.Container;
    private readonly _shineContainerRight: PIXI.Container;
    private readonly _maskContainer: PIXI.Container;

    private readonly _lineShineMaskMap: Map<number, IShineMask> = new Map();
    private _shineObj: PIXI.Sprite;
    private _gameView: RomanEmpireInitialWPView;
    private _isGeniePresent: boolean = true;
    private _highlightSoundPlayArr: boolean[] = [];
    public static SCATTER_ANIM_CONTAINER: PIXI.Container;
    private _isSnakeSoundPlayed: boolean = false;
    private _isLeopardSoundPlayed: boolean = false;
    //private _scatterArr : any[][] = [];

    constructor(indexes: [number, number]) {
        super(indexes);

        this._winCountUp = new RomanEmpireInitialWinCountUp();
        this._winCountUp.position.set(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X, GameConfig.instance.GAME_HEIGHT * 0.5);
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);

        this._multiplierContainer = new PIXI.Container();
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.WIN_MULTIPLIER.name).addChild(this._multiplierContainer);
        this._shineContainerLeft = new PIXI.Container();
        this._shineContainerLeft.name = "SHINE_CONTAINER_LEFT";
        this._shineContainerRight = new PIXI.Container();
        this._shineContainerRight.name = "SHINE_CONTAINER_RIGHT";
        this._maskContainer = new PIXI.Container();
        this._gameView = new RomanEmpireInitialWPView();
        RomanEmpireInitialWPController.SCATTER_ANIM_CONTAINER = new PIXI.Container();
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.SYMBOLS.name).addChild(RomanEmpireInitialWPController.SCATTER_ANIM_CONTAINER);
    }

    protected startWinPresentation(): void {
        //this._animalSoundPlayedInReSpin = false;
        this._isSnakeSoundPlayed = false;
        this._isLeopardSoundPlayed = false;
        if (this._gameData!.isBigWin) {
            SoundManager.playSound(RomanEmpireSoundConfig.instance.BIG_WIN_INITIAL_WIN);
            SoundManager.fadeSound(this._gameData?.mode == RomanEmpireGameMode.GENIE_RESPIN ? RomanEmpireSoundConfig.instance.BACKGROUND_MUSIC_FS : RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 1000, 0);
            SoundManager.fadeSound(RomanEmpireSoundConfig.instance.MEDIUM_AND_LARGE_WIN, 1000, 0);//#244
        } else {
            const winSound: string | null = RomanEmpireSoundConfig.getNormalWinSoundName(this._gameData!.currentWinRatioConfig!.type!);
            if (winSound && !RomanEmpireGameConfig.instance.WIN_BELOW_STAKE) {
                SoundManager.playSound(winSound);
            }
        }
        super.startWinPresentation();
    }


    protected addFeatureEventHandlers(): void {
        EventHandler.addEventListener(this, RomanEmpireEvents.ON_LINE_SHINE_MASK_CREATED, (event: GameEvent) => this.onLineShineMaskCreated(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, RomanEmpireEvents.BET_LINES_DRAW_COMPLETED, () => this.onBetLinesDrawCompleted());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => {
            //this._scatterArr = [];
            RomanEmpireInitialWPController.SCATTER_ANIM_CONTAINER.removeChildren();
        });
    }

    protected playAllNoWinSymbols(timeline: Timeline): void {
        super.playAllNoWinSymbols && super.playAllNoWinSymbols(timeline);
    }

    protected getNextSymbolAnimationTimeOffset(duration: number): number {
        if ((this._gameData as RomanEmpireParsedGameData).mode == RomanEmpireGameMode.GENIE_RESPIN) {
            return (this.GENIE_RESPIN_BETLINE_ANIM_TIME_OFFSET - 0.1) || duration;
        }
        return duration || (this.BETLINE_ANIM_TIME_OFFSET - 0.1);
    }

    protected getNextBetWinAnimationTimeOffset(lastSymbolDelay: number): number {
        if ((this._gameData as RomanEmpireParsedGameData).mode == RomanEmpireGameMode.GENIE_RESPIN) {
            return this.GENIE_RESPIN_BETLINE_ANIM_TIME_OFFSET || lastSymbolDelay;
        }
        return 0.2;
    }

    private shouldPlayMediumLargeWinSound(): boolean {
        const gameData = (this._gameData as RomanEmpireParsedGameData);
        return !((gameData.mode == RomanEmpireGameMode.NORMAL && gameData.nextMode == RomanEmpireGameMode.GENIE_RESPIN) || (gameData.mode == RomanEmpireGameMode.GENIE_RESPIN));
    }

    protected addWinCountUpToTimeline(timeline: Timeline): void {
        // #315
        timeline.add(this.showBetlineAmountInitialWin(this._betWinsData!), 0);
        if (this._gameData!.isBigWin) {
            return;
        }

        const totalWin: number = this._gameData!.totalWin;
        let win = (this._gameData as RomanEmpireParsedGameData).totalSpinWinningsMultiplied;
        const from: number = totalWin - win;
        const duration: number = this._gameData!.currentWinRatioConfig!.duration;
        const isPlayCountUpEndSoundInReSpin: boolean = this._gameData?.mode == RomanEmpireGameMode.GENIE_RESPIN &&
            (this._gameData!.currentWinRatioConfig?.type == WinRatioType.TINY || this._gameData!.currentWinRatioConfig?.type == WinRatioType.SMALL)
        const countUpTimeline: TimelineLite = new TimelineLite();
        countUpTimeline.add(this._winCountUp.getCountUpAnimation(0, win, duration, this._gameData!.currentMultiplier, isPlayCountUpEndSoundInReSpin),);

        //#240 If we get 3 scatters or more, never play background-music-main2. Even if that scatter win include a normal win, like MEDIUM, LARGE and BIGWIN wins.
        //win Fountain if win is greater then bet && WinRatioType is not SMALL
        if (this.getIsWinType(WinRatioType.LARGE) || this.getIsWinType(WinRatioType.MEDIUM)) {
            this.shouldPlayMediumLargeWinSound() && SoundManager.playMediumAndLargeWinSound();
            timeline.add(() => {
                this._gameView.startWinFountain();
            }, this.getWinCountUpDelay(timeline));
        }

        countUpTimeline.add(() => SlotGame.winFieldController.showWinField());
        timeline.add(countUpTimeline, this.getWinCountUpDelay(timeline));

        if ((this._gameData as RomanEmpireParsedGameData).mode == RomanEmpireGameMode.GENIE_RESPIN) {
            timeline.add(TweenLite.to(this, 1, {}));//to fixed #192 added 1 sec pause.
        }
    }

    protected stopWinPresentation(isAborted: boolean): void {
        let win = (this._gameData as RomanEmpireParsedGameData).totalSpinWinningsMultiplied;

        this._winCountUp.abort(win, isAborted, this._gameData!.currentMultiplier, this._gameData!.isBigWin);
        isAborted && this._gameView.stopWinFountain();
        this.stopMultiplierAnim(isAborted);
        this.resetShineAnimation();
        //super.stopWinPresentation(isAborted);
        if (this._timeline) {
            if (this._timeline.isActive()) {
                this._timeline.pause();
                this._timeline.kill();
            }
            this._timeline = null;
        }
        // #315
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).removeChildren();
        //code commented to fix #270.
        // while (this._winSymbols.length > 0) {
        //     this._winSymbols.pop()?.changeState({
        //         state: RomanEmpireGameConfig.instance.SYMBOL_STATES.normal,
        //         frames: [-1, -1]
        //     });
        // }
        this._winSymbols.length = 0;
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
        RomanEmpireGameModuleConfig.foregroundAnimation.reset();
        if (isAborted) {
            if (this._gameData!.isBigWin) {
                //SlotGame.sound.fadeAmbience(0, 500);
            } else {
                SlotGame.winFieldController.showWinField();
            }
        }
    }


    /**
     * Override parent class function to create multiplier animation for Genie Respin feature
     * and play shine animation on initial winning bet lines.
     * @param timeline
     */
    protected addWinAnimationsToTimeline(timeline: gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax): void {
        this._shineContainerLeft.removeChildren();
        this._shineContainerRight.removeChildren();
        this._maskContainer.removeChildren();
        var startTime = 0;
        let betWindata: any = this._betWinsData;
        this._highlightSoundPlayArr = ArrayHelper.initArrayWithValues(5, () => false);
        for (var i = 0; i < betWindata!.length; i++) {
            startTime += this.addSingleBetWinAnimationToTimeline(betWindata![i], timeline as any, startTime);
        }
        if ((this._gameData as RomanEmpireParsedGameData).mode == RomanEmpireGameMode.GENIE_RESPIN) {
            this._isGeniePresent && this.createAndPlayMultiplierAnimation();
        }
        let stTime = (this._gameData?.mode === RomanEmpireGameMode.NORMAL) ? 0.1 : startTime;
        this.playShineAnimationOnBetLine(timeline, stTime);
        //timeline.add(TweenLite.to({}, 5, {}))
        (this._gameData as RomanEmpireParsedGameData).isRandomBothWaysTriggered && this.hasWin() && RomanEmpireGameModuleConfig.foregroundAnimation.playExpandWildAnimation(true);
    }

    protected hasWin(): boolean {
        return (this._betWinsData != null && this._betWinsData.length > 0);
    }

    protected getWinCountUpDelay(timeline: Timeline): number {
        if ((this._gameData as RomanEmpireParsedGameData).mode == RomanEmpireGameMode.GENIE_RESPIN) {
            return this._multiplierTotalAnimDuration - this.GENIE_RESPIN_BETLINE_ANIM_TIME_OFFSET;
        }if(RomanEmpire.api.gameClientConfiguration.displayIndividualWinsInGame && !RomanEmpireGameConfig.instance.WIN_BELOW_STAKE){
            return timeline.totalDuration();
        } else {
            return 0;
        }
    }

    private playWinHighlightSound() {
        SoundManager.playSound(RomanEmpireSoundConfig.instance.WIN_SYMBOL_HIGHLIGHT)
    }

    /**
     * Override parent class function to add bet line shine animation.
     * @param betLineWinData
     * @param timeline
     * @param startTime
     */
    protected addSingleBetWinAnimationToTimeline(betLineWinData: IBetLineBothWayWinData, timeline: TimelineLite, startTime: number): number {
        const symbolsNum: number = betLineWinData.nrOfSymbols;
        let symbol: StateReelSymbol | null;
        let symbolDelay: number = 0;

        if (betLineWinData.lineStart === "Right") {
            for (let i: number = betLineWinData.betLine.length - 1; i >= betLineWinData.betLine.length - betLineWinData.nrOfSymbols; i--) {
                symbol = this.findSymbol(i, betLineWinData.betLine[i]);
                if (!symbol) {
                    debugger;
                    throw new Error(`Error: RomanEmpireInitialWPController.addSingleBetWinAnimationToTimeline(): Cannot find symbol at reel ${i} symbol ${betLineWinData.betLine[i]}`);
                }
                symbolDelay += this.addSymbolWinAnimationToTimeline(betLineWinData, timeline, startTime + symbolDelay, symbol!, i, betLineWinData.betLine[i]);
                if (this._winSymbols.indexOf(symbol) === -1) {
                    this._winSymbols.push(symbol);
                }
            }
        } else {
            for (let i: number = 0; i < symbolsNum; i++) {
                symbol = this.findSymbol(i, betLineWinData.betLine[i]);
                if (!symbol) {
                    debugger;
                    throw new Error(`Error: RomanEmpireInitialWPController.addSingleBetWinAnimationToTimeline(): Cannot find symbol at reel ${i} symbol ${betLineWinData.betLine[i]}`);
                }
                symbolDelay += this.addSymbolWinAnimationToTimeline(betLineWinData, timeline, startTime + symbolDelay, symbol!, i, betLineWinData.betLine[i]);
                if (this._winSymbols.indexOf(symbol) === -1) {
                    this._winSymbols.push(symbol);
                }
            }
        }
        if (this._betLineWinConfig.shouldPlayBetLine) {
            timeline.add(() => this.playBetLine!(betLineWinData.betLineIndex + 1), startTime);
            if (this._gameData?.mode == RomanEmpireGameMode.GENIE_RESPIN) {
                if ((betLineWinData.symbol == "M5" || betLineWinData.symbol == "M4") && !this._isSnakeSoundPlayed && !this._isLeopardSoundPlayed && !RomanEmpireGameConfig.instance.WIN_BELOW_STAKE) {
                    //this._animalSoundPlayedInReSpin = true;
                    if (betLineWinData.symbol == "M4" && !this._isSnakeSoundPlayed) {
                        this._isSnakeSoundPlayed = true;
                        timeline.add(() => SoundManager.playSnake(), startTime);
                    }
                    if (betLineWinData.symbol == "M5" && !this._isLeopardSoundPlayed) {
                        this._isLeopardSoundPlayed = true;
                        timeline.add(() => SoundManager.playLeopard(), startTime);
                    }
                }
                if (!RomanEmpireGameConfig.instance.WIN_BELOW_STAKE) {
                    timeline.add(() => SoundManager.playFSWinLine(), startTime);
                }
            } else if (!RomanEmpireGameConfig.instance.WIN_BELOW_STAKE) {
                if (betLineWinData.symbol == "M4" && !this._isSnakeSoundPlayed) {
                    this._isSnakeSoundPlayed = true;
                    timeline.add(() => SoundManager.playSnake(), startTime);
                }
                if (betLineWinData.symbol == "M5" && !this._isLeopardSoundPlayed) {
                    this._isLeopardSoundPlayed = true;
                    timeline.add(() => SoundManager.playLeopard(), startTime);
                }
            }
            this.createBetLineShine(betLineWinData.betLineIndex + 1, betLineWinData.lineStart);
        }

        return (this._gameData?.mode === RomanEmpireGameMode.NORMAL) ? 0 : this.getNextBetWinAnimationTimeOffset(symbolDelay);
    }

    //if randomBothWay triggered skip 2nd and 4th reel symbol anim
    private isSkipSymbolAnimFor2ndAnd4thReel(reelId: number): boolean {
        return (this._gameData as RomanEmpireParsedGameData).isRandomBothWaysTriggered && (reelId == 1 || reelId == 3);
    }


    private getScatterSprite(textureStr: string, position?: ISymbolPositions): TimelineSprite {
        const textures: PIXI.Texture[] = GameResources.getTextures(textureStr);
        const sprite: TimelineSprite = new TimelineSprite(textures, 30);
        sprite.anchor.set(0.5, 0.5);
        if (position) {
            const pos = Helper.getSymbolPositions(position.reelId, position.symbolId);
            sprite.position.set(pos[0], pos[1]);
        }
        return sprite;
    }

    /**
     * function to create scatter animation for initial win
     * @param reelId
     * @param symId
     */
    private scatterInitialWinAnimation(reelId: number, symId: number): TimelineSprite {
        const scatterAnticipationAnim : any = this.getScatterSprite("scatterAnticipationIdle", {
            reelId: reelId,
            symbolId: symId
        });
        scatterAnticipationAnim.symId = symId;
        scatterAnticipationAnim.reelId = reelId;
        //reArrange logic
        RomanEmpireInitialWPController.SCATTER_ANIM_CONTAINER.addChild(scatterAnticipationAnim);
        return scatterAnticipationAnim;
    }

    protected addSymbolWinAnimationToTimeline(betLineWinData: IBetLineWinData, timeline: gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax, startTime: number, symbol: StateReelSymbol, reelId: number, symbolId: number): number {
        if (!this.isSkipSymbolAnimFor2ndAnd4thReel(reelId)) {
            let isWinTypeSmallOrTiny: boolean = this.getIsWinType(WinRatioType.TINY) || this.getIsWinType(WinRatioType.SMALL);
            let symState: ISymbolStateConfig = RomanEmpireGameConfig.instance.SYMBOL_STATES.win;
            // this.playWinHitSound(reelId);
            let symbolAnimation: Timeline;
            let symbolSparkleAnimation: Timeline;

            // #307
            if (RomanEmpireGameConfig.instance.WIN_BELOW_STAKE) {
                symbolSparkleAnimation = symbolAnimation = (new TimelineLite()).to({}, 1, {});
            } else {
                symbolAnimation = RomanEmpireGameModuleConfig.foregroundAnimation.getSymbolAnimShow(reelId, symbolId, symbol);
                symbolSparkleAnimation = RomanEmpireGameModuleConfig.foregroundAnimation.show(reelId, symbolId);
            }

            if (!isWinTypeSmallOrTiny && !this._highlightSoundPlayArr[reelId]) {
                this._highlightSoundPlayArr[reelId] = true;
                timeline.add(() => this.playWinHighlightSound(), reelId * 0.1);
            }
            timeline.add([
                symbolAnimation,
                symbolSparkleAnimation,
                () => {
                    this.sortSymbolDepthToTop(symbol)
                },
                () => {
                    if (symbol.symName == "S") {
                        let anim = this.scatterInitialWinAnimation(reelId, symbolId);
                        anim.getAnimationAutoShowHide(true, false);
                    } else {
                        symbol.changeState({
                            state: RomanEmpireGameConfig.instance.SYMBOL_STATES.initialWin || symState, //#249 add animal sound with animation to add initial sym anim
                            fadeInDuration: 0
                        }, {
                            fadeOutDuration: 0,
                        fadeOutDelay: 0.01
                    })
                    }
                },
            ], (isWinTypeSmallOrTiny) ? 0.1 : reelId * 0.1);
            return this.getNextSymbolAnimationTimeOffset(symbolSparkleAnimation.totalDuration());
        } else {
            return this.getNextSymbolAnimationTimeOffset(0.6);
        }

    }

    /**
     * To play initial winning bet line shine animation.
     * @param timeline
     */
    protected playShineAnimationOnBetLine(timeline: gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax, startTime: number): void {
        timeline.add(() => {
            TweenLite.fromTo(this._shineContainerLeft, 0.8, {x: 0}, {
                x: RomanEmpireGameConfig.instance.GAME_WIDTH, onComplete: () => {
                    Logger.logDev("playShineAnimationOnBetLine left to right completed");
                }
            });
        }, startTime);
        if (this._shineContainerRight.children.length) {
            timeline.add(() => {
                TweenLite.fromTo(this._shineContainerRight, 0.8, {x: RomanEmpireGameConfig.instance.GAME_WIDTH}, {
                    x: 0, onComplete: () => {
                        Logger.logDev("playShineAnimationOnBetLine right to left completed");
                    }
                });
            }, startTime);
        }
    }

    protected parseFeatureGameData(data: RomanEmpireParsedGameData): void {
        //super.parseFeatureGameData(data);
        if (data?.bothWayWins?.length) {
            // data.bothWayWins[0].lineStart = "right"; //only for testing
            this._betWinsData = data.betWins?.concat(data.bothWayWins);
        }
        this._isGeniePresent = data.reSpinsRemaining >= 0;

        // #307
        RomanEmpireGameConfig.instance.WIN_BELOW_STAKE = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= data.playedBetValue));
    }

    private onBetLinesDrawCompleted() {
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name).addChildAt(this._maskContainer, RomanEmpireGameConfig.instance.TOTAL_BET_LINES);
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name).addChildAt(this._shineContainerLeft, RomanEmpireGameConfig.instance.TOTAL_BET_LINES);
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name).addChildAt(this._shineContainerRight, RomanEmpireGameConfig.instance.TOTAL_BET_LINES);
    }

    private onLineShineMaskCreated(index: number, mask: IShineMask) {
        this._lineShineMaskMap.set(index, mask);
    }

    private stopMultiplierAnim(isAborted: boolean): void {
        if (this._masterTimeline && this._masterTimeline.isActive()) {
            this._masterTimeline.pause();
            this._masterTimeline.kill();
        }
        this._multiplierContainer.removeChildren();
    }

    private resetShineAnimation() {
        this._maskContainer.removeChildren();
        this._shineContainerLeft.removeChildren();
        this._shineContainerRight.removeChildren();
    }

    /**
     * To play multiplier animation over bet lines in Genie Respin.
     */
    private createAndPlayMultiplierAnimation() {
        if (this._masterTimeline && this._masterTimeline.isActive()) {
            this._masterTimeline.pause().kill();
        }
        this._masterTimeline = new TimelineLite();
        this._multiplierTotalAnimDuration = this.getNextBetWinAnimationTimeOffset(this.GENIE_RESPIN_BETLINE_ANIM_TIME_OFFSET) * (this._betWinsData!.length || 0) + RomanEmpireInitialWPController.BET_LINE_MIN_DURATION;
        for (let i: number = 0; i < this._betWinsData!.length; i++) {
            let animatedMultiplier: AnimatedMultiplier = new AnimatedMultiplier(this._betWinsData![i] as RomanEmpireBetLineWinData);
            this._multiplierContainer.addChild(animatedMultiplier);
            this._masterTimeline.add(() => animatedMultiplier.getAnimationTween(), this.getNextBetWinAnimationTimeOffset(this.GENIE_RESPIN_BETLINE_ANIM_TIME_OFFSET) * i);
        }
        this._masterTimeline.play();
    }

    /**
     * To create bet line shine for initial win.
     * @param betlineIndex
     */
    private createBetLineShine(betlineIndex: number, lineStart: string): void {
        this._shineObj = new LineShine();
        (lineStart === "Right") ? this._shineContainerRight.addChild(this._shineObj) : this._shineContainerLeft.addChild(this._shineObj);

        const shineMaskPos: IShineMask | undefined = this._lineShineMaskMap.get(betlineIndex);
        if (shineMaskPos) {
            const lineShineMask: LineShineMask = new LineShineMask(GameResources.getTextures(shineMaskPos.textureStr)[0], shineMaskPos);
            this._shineObj.mask = lineShineMask;
            this._maskContainer.addChild(lineShineMask);
        } else {
            debugger;
            Logger.warn("mask data not available for betLineIndex in lineShineMask map", betlineIndex);
        }
        this._shineObj.width = this._shineObj.width + 100;
        this._shineObj.height = this._shineObj.height + 600;
    }

    private getIsWinType(checkFor: string): boolean {
        let winRatioConfig = this._gameData!.currentWinRatioConfig!;
        if (winRatioConfig.type === checkFor) {
            return true;
        }
        return false;
    }

    // #315
    private showBetlineAmountInitialWin(betWins: IBetWinData[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            container: PIXI.Container = new PIXI.Container();

        if (RomanEmpireGameConfig.instance.WIN_BELOW_STAKE || !RomanEmpire.api.gameClientConfiguration.displayIndividualWinsInGame) {
            return tl;
        }

        container.position.set(360, 360);
        container.alpha = 0;

        betWins.forEach((betWin: IBetWinData, idx: number) => {
            // const winAmount: PIXI.Text = new PIXI.Text(betWin.multipliedAmount.toFixed(2), new PIXI.TextStyle({
            //     fontFamily: OpenSans.FAMILY,
            //     fontSize: 36,
            //     fontWeight: FontWeight.BOLD,
            //     fill: "#fff"
            // }));

            const winAmount : PIXI.BitmapText = new PIXI.BitmapText(betWin.multipliedAmount.toFixed(2),{
                fontName : "NumbersWinCountUp",
                fontSize: 16,
                tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
            })
            let effectiveIdx: number = idx;

            if (betWins.length > 20 && (idx >= (betWins.length / 2))) {
                effectiveIdx = (idx - (betWins.length / 2));
                winAmount.x = (container.children[0] as PIXI.Text).width + 30; // #325
            }

            winAmount.y = (effectiveIdx * 45);
            container.addChild(winAmount);
        });

        if (betWins.length > 13) {
            container.scale.set(0.65);
            container.y -= 90;
        }
        container.pivot.set(container.width / 2, container.height / 2);

        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).addChild(container);

        tl.to(container, 0.1, {
            alpha: 1
        });
        tl.to(container, 0.7, {
            y: "-=50"
        });
        tl.to(container, 0.2, {
            alpha: 0
        });
        tl.add(() => {
            container.removeChildren();
            StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).removeChild(container);
        });

        return tl;
    }

}

